module.exports = __webpack_public_path__ + "static/media/top14Socialbanner2400x1260CENTERCROP_@2x.d115ca73.jpg";